import styled from 'styled-components';

const Mono = styled.pre`
  display: inline;
  margin: 0;
`;

export default Mono;
